import "./App.css";
import Main from "./Component/Main";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Privacy from "./Component/Privacy";
import ProductDetail from "./Component/ProductDetail";
import CartPage from "./Component/CartPage";
import CheckOut from "./Component/CheckOut";
import { CartProvider } from "./Component/CartContext";
import PaySuccess from "./Component/SuccessPay";
import Terms from "./Component/Terms";
import Shop from "./Component/Shop";
import Contact from "./Component/Contact";
import Returns from "./Component/Returns";
import About from "./Component/About";
import Header from "./Component/Header";
import Footer from "./Component/Footer";
import Delivery from "./Component/Delivery";
import FAQs from "./Component/FAQs";
import Cookies from "./Component/Cookies";
import PolicyCenter from "./Component/PolicyCenter";
import {
  Accessibility,
  Cancellations,
  Complaints,
  DataCollection,
  GiftCards,
  IntellectualProperty,
  Payments,
  ProductCare,
  Promotions,
  Security,
  Warranty,
} from "./Component/AdditionalPolicies";

function App() {
  return (
    <CartProvider>
      <Router>
         <Header />
        <Routes>
         
          <Route path="/about" element={<About />} />
          <Route path="/shipping" element={<Delivery />} />
          <Route path="/" element={<Main />} />
          <Route path="/returns" element={<Returns />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/faqs" element={<FAQs />} />
          <Route path="/cookies" element={<Cookies />} />
          <Route path="/policies" element={<PolicyCenter />} />
          <Route path="/data-collection" element={<DataCollection />} />
          <Route path="/payments" element={<Payments />} />
          <Route path="/cancellations" element={<Cancellations />} />
          <Route path="/warranty" element={<Warranty />} />
          <Route path="/product-care" element={<ProductCare />} />
          <Route path="/promotions" element={<Promotions />} />
          <Route path="/gift-cards" element={<GiftCards />} />
          <Route path="/intellectual-property" element={<IntellectualProperty />} />
          <Route path="/accessibility" element={<Accessibility />} />
          <Route path="/security" element={<Security />} />
          <Route path="/complaints" element={<Complaints />} />
          <Route path="/shopDetails/:id" element={<ProductDetail />} />
          <Route path="/cartpage" element={<CartPage />} />
          <Route path="/checkout" element={<CheckOut />} />
          <Route path="/payment" element={<PaySuccess />} />
          <Route path="/paysuccess" element={<PaySuccess />} />
         
        </Routes> <Footer />
      </Router>
    </CartProvider>
  );
}

export default App;
